var radio = require("react-pubsub-via-radio.js/radio");
var _ = require('lodash');

var hashChange = (function(){
	if(typeof window === 'undefined'){
		return _.noop;
	}
	var oldHref = null;//start with nothing so the first page load gets broadcasted
	return function(e){
		var newHref = (!!e && e.newURL) || window.location.href;
		oldHref = (!!e && e.oldURL) || oldHref;

		if(oldHref !== newHref){
			radio('Hashbang_changed').broadcast(parse_url(newHref), newHref, oldHref);
			oldHref = newHref;
		}
	};
}());

radio('Hashbang_set').subscribe(function(new_url){
	if(_.isString(new_url)){
		window.location.hash = new_url;
		hashChange();
	}
});

module.exports.init = function(){
	if(typeof window === 'undefined'){
		return;
	}
	if(!('onhashchange' in window)){
		setInterval(hashChange, 100);
	}else if(window.addEventListener){
		window.addEventListener('hashchange', hashChange, false);
	}else if(window.attachEvent){
		window.attachEvent('onhashchange', hashChange);
	}
	hashChange();//trigger the initial broadcast
};

var parse_url = (function(){
	var parse_url_regex = /^(?:([A-Za-z]+):)?(?:\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;//thanks for the good parts Douglas Crockford
	var names = ['url', 'scheme', 'host', 'port', 'path', 'query', 'hash'];

	return function(url){
		var result = parse_url_regex.exec(url);
		return _.object(_.filter(_.zip(names, result), function(keyvalpair){
			return !!keyvalpair[1];//remove any empty values
		}));
	};
}());



//////////////////
// WEBPACK FOOTER
// ./~/ES/services/Hashbang.js
// module id = 181
// module chunks = 0 1 2 3 4